import { Icon } from "@chakra-ui/react"
import { FaHeart } from "react-icons/fa"
import { useAppSelector } from "../../app/hooks"
import MeterBar from "../../components/MeterBar"
import {
  selectGamePhysicalHealth,
  selectLastTurnPhysicalHealthEffect,
  selectLastTurnNonce,
} from "./gameSlice"

// Hoisted so the memoised MeterBar sees a stable icon prop
const ICON = <Icon boxSize={6} as={FaHeart} />

export const PhysicalHealthMeter = () => {
  const value = useAppSelector(selectGamePhysicalHealth)
  const effect = useAppSelector(selectLastTurnPhysicalHealthEffect)
  const nonce = useAppSelector(selectLastTurnNonce)

  return (
    <MeterBar
      label="Health"
      value={value}
      max={100}
      icon={ICON}
      effect={effect}
      nonce={nonce}
    />
  )
}
